<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới cấu hình menu</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="top" :model="modelData" ref="createModel">
            <el-form-item prop="position" label="Chọn vị trí menu cần cấu hình" class="form-item">
              <el-select v-model="modelData.position" filterable placeholder="" class="input-select">
                <el-option
                  v-for="item in lists.listCategoryBlogs"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="name" label="Tên" class="form-item">
              <el-input v-model="modelData.name" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item prop="link" label="Đường link" class="form-item">
              <el-input type="textarea" :rows="5" v-model="modelData.link" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Cấu hình menu | Thêm'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        position: 1,
        name: '',
        link: '',
        status: true
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configmenus-index', text: 'Cấu hình menu' },
        { name: 'configmenus-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'configmenus-index'})
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('configmenus', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm cấu hình thành công',
              type: 'success'
            })
            this.$router.push({name: 'configmenus-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/configmenus/Create.vue